import { useStoreApi } from '@givebacks/api/store';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { storeKeys } from '../../../query-key-factory';
import { PeerTypes } from '../../types';
import { CreatePeerRequest, PeersResponse } from './types';
import { constructPeerFormData } from './utils';

const useCreateCampaignPeer = <T extends PeerTypes>({ peerType }: { peerType: T }) => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const createPeer = async ({ causeId, campaignId, ...rest }: CreatePeerRequest<T>) => {
    if (!causeId || !campaignId) throw new Error('Missing required value');

    const form = constructPeerFormData<T>({ causeId, campaignId, peerType, request: rest });

    const { data } = await StoreApi.post<PeersResponse<T>>(
      `/store_items/${campaignId}/${peerType}`,
      form
    );
    return data[peerType == 'participants' ? 'participant' : 'team'];
  };
  return useMutation({
    mutationFn: createPeer,
    onSuccess(_, variables) {
      const { causeId, campaignId } = variables;
      const key =
        campaignId && causeId
          ? storeKeys.id(causeId).items.campaigns.id(campaignId)[peerType].all
          : undefined;
      queryClient.invalidateQueries({ queryKey: key });
    },
  });
};

export { useCreateCampaignPeer };
